// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Style zakładki Urlopy (Biuro → Urlopy). Wydzielone ze Scrumboard.css razem
   z komponentem: strona nie jest już częścią scrumboardu, więc nie powinna ciągnąć
   za sobą jego arkusza. */

.vacations-scroll {
    overflow-x: auto;
}

.vacation-legend {
    font-size: 0.85rem;
}

.vacation-legend-item {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    white-space: nowrap;
}

.vacation-swatch,
.vacation-bar {
    border-radius: 0.2rem;
}

.vacation-swatch {
    display: inline-block;
    width: 0.9rem;
    height: 0.9rem;
}

/* Kolumny osoby i urlopu — dynamiczne, zwężone do treści (width:1% + nowrap),
   dzięki czemu dni miesiąca / timeline dostają całą pozostałą szerokość. */
.vacation-name-col {
    width: 1%;
    white-space: nowrap;
    vertical-align: middle;
}

.vacation-balance-col {
    width: 1%;
    white-space: nowrap;
    vertical-align: middle;
}

/* Wspólna wysokość treści sald: zwiniętej, rozwiniętej i nagłówka. Bez niej
   zwinięcie skracałoby wiersze, bo goła liczba jest niższa niż pole edycji.
   Szerokości zostają naturalne (width: 1% + nowrap), więc nic nie jest wpisane
   na sztywno i nic się nie obetnie przy nietypowo długiej wartości. */
.vacation-balance-head-row,
.vacation-pool-grid,
.vacation-balance-row {
    min-height: 1.65rem;
}

/* Nagłówek sald jest przełącznikiem zwijania — stąd kursor i brak zaznaczania
   tekstu przy podwójnym kliku. Bez podkreślenia: reaguje sama strzałka. */
.vacation-balance-head {
    cursor: pointer;
    user-select: none;
}

.vacation-balance-head-row {
    display: flex;
    align-items: center;
    white-space: nowrap;
}

/* margin-left: auto dosuwa strzałkę do prawej krawędzi kolumny — zwiniętej tuż za
   "święta", rozwiniętej na końcu kolumny "Za święta". */
.vacation-chevron {
    flex: none;
    margin-left: auto;
    padding-left: 0.5rem;
    font-size: 0.7rem;
    line-height: 1;
    color: var(--bs-secondary-color, #6c757d);
}

/* Widok zwinięty: trzy pule obok siebie. Ta sama siatka w nagłówku (etykiety)
   i w komórkach (liczby), więc "2" zawsze stoi pod "opieka" bez ręcznego
   dobierania szerokości. */
.vacation-pool-grid {
    display: grid;
    grid-template-columns: repeat(3, 3.1rem);
    align-items: center;
    gap: 0.15rem;
    text-align: center;
    font-size: 0.8rem;
    line-height: 1.4;
}

.vacation-pool-labels {
    min-height: 0;
    font-size: 0.65rem;
    font-weight: 400;
    text-transform: lowercase;
    color: var(--bs-secondary-color, #6c757d);
}

.vacation-balance-row {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    font-size: 0.78rem;
    white-space: nowrap;
}

.vacation-limit-field {
    display: inline-flex;
    align-items: center;
    gap: 0.2rem;
    margin: 0;
}

.vacation-limit-input {
    width: 3rem;
    padding: 0.1rem 0.25rem;
    min-height: 0; /* zdejmuje stałą min-height form-control-sm, by input miał tę samą wysokość co span odczytu */
    text-align: center;
}

/* Stała szerokość etykiety miesiąca — strzałki ‹ › nie przeskakują między miesiącami. */
.vacation-month-label {
    width: 7rem;
}

/* Wartość limitu w trybie odczytu — ten sam gabaryt co input (form-control-sm),
   dzięki czemu wiersz nie zmienia wysokości przy wejściu/wyjściu z edycji. */
.vacation-limit-value {
    display: inline-block;
    box-sizing: border-box;
    width: 3rem;
    padding: 0.1rem 0.25rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    font-size: 0.875rem;
    line-height: 1.5;
    text-align: center;
    cursor: pointer;
}

/* Podświetlenie pod kursorem — to jedyne, co polu limitu dawała wspólna klasa
   .scrum-inline-value ze Scrumboard.css; reszta jej reguł i tak była nadpisana. */
.vacation-limit-value:hover {
    background-color: var(--bs-warning-bg-subtle, #fff3cd);
}

/* Widok roczny — proporcjonalny timeline */
.vacation-year td,
.vacation-year th {
    vertical-align: middle;
}

.vacation-track {
    position: relative;
    height: 100%;
    min-height: 1.9rem;
    min-width: 40rem;
    width: 100%;
}

.vacation-track-header {
    height: 1.1rem;
    min-height: 0;
}

.vacation-tick {
    position: absolute;
    top: 0;
    transform: translateX(-2px);
    font-size: 0.7rem;
    color: var(--bs-secondary, #6c757d);
}

.vacation-gridline {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 1px;
    background: var(--bs-border-color, #dee2e6);
}

.vacation-bar {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    height: 1rem;
    min-width: 3px;
    cursor: pointer;
    opacity: 0.9;
}

.vacation-bar:hover {
    opacity: 1;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
}

/* Widok miesięczny — siatka dni rozciąga się na całą dostępną szerokość */
.vacation-month {
    width: 100%;
}

.vacation-day-head,
.vacation-day-cell {
    min-width: 1.4rem;
    text-align: center;
    padding: 0.15rem 0;
}

.vacation-day-head {
    font-size: 0.75rem;
}

.vacation-day-cell {
    height: 1.6rem;
    cursor: pointer;
}

.vacation-day-cell:hover {
    outline: 1px solid var(--bs-primary, #0d6efd);
    outline-offset: -1px;
}

/* Weekend zawsze wyszarzony (także wewnątrz zakresu urlopu — nie liczy się do dni) */
.vacation-weekend {
    background-color: var(--bs-secondary-bg, #e9ecef);
    background-image: repeating-linear-gradient(
        45deg,
        rgba(0, 0, 0, 0.05) 0,
        rgba(0, 0, 0, 0.05) 2px,
        transparent 2px,
        transparent 4px
    );
    color: var(--bs-secondary, #6c757d);
}

/* Kolumna timeline: bez pionowych marginesów + trik height:1px, dzięki któremu
   .vacation-track (height:100%) wypełnia pełną wysokość wiersza —
   linia "dziś" jest wtedy ciągła (bez przerw między wierszami). */
.vacation-timeline-cell {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    height: 1px;
}

/* Wskaźnik "dziś" — widok roczny: jedna ciągła pionowa linia.
   Anchor = komórka (pełna wysokość wiersza), wyciek ±1px kryje obramowania. */
.vacation-today-line {
    position: absolute;
    top: -1px;
    bottom: -1px;
    width: 2px;
    transform: translateX(-1px);
    background: rgba(220, 53, 69, 0.55);
    z-index: 3;
    pointer-events: none;
}

/* Wskaźnik "dziś" — widok miesięczny: subtelna ramka kolumny dnia. */
.vacation-day-cell.vacation-today {
    box-shadow: inset 1px 0 0 rgba(220, 53, 69, 0.55),
        inset -1px 0 0 rgba(220, 53, 69, 0.55);
}

/* Domknięcie ramki dołem na ostatnim wierszu. */
.vacation-month tbody tr:last-child .vacation-day-cell.vacation-today {
    box-shadow: inset 1px 0 0 rgba(220, 53, 69, 0.55),
        inset -1px 0 0 rgba(220, 53, 69, 0.55),
        inset 0 -1px 0 rgba(220, 53, 69, 0.55);
}

.vacation-day-head.vacation-today {
    background-color: rgba(220, 53, 69, 0.08);
    font-weight: 600;
    box-shadow: inset 1px 0 0 rgba(220, 53, 69, 0.55),
        inset -1px 0 0 rgba(220, 53, 69, 0.55),
        inset 0 1px 0 rgba(220, 53, 69, 0.55);
}

/* Nieobecność na CZĘŚĆ DNIA — poziome prążki zamiast litego wypełnienia.
   TA SAMA klasa dla kratki miesiąca i dla paska rocznego: paski biegną w poprzek
   wąskiego wymiaru, więc na pasku szerokim na 3 px nadal daje się je policzyć,
   a pionowe zmieściłyby się tam najwyżej raz.

   Znacznik jest DWUSTANOWY, nie miarą: 1 h i 7 h wyglądają identycznie. Różnica
   między 6 h a 7 h jest w kratce 26 px nieczytelna, a udawanie, że jest czytelna,
   wprowadzałoby w błąd. Liczbę godzin niesie dymek i okno edycji.

   Kolizji z weekendem nie ma: weekend rysuje się na ukos (45°), część dnia poziomo.

   WZÓR LICZONY W UŁAMKACH WYSOKOŚCI, NIE W PIKSELACH — i to jest sedno tej reguły.
   Dwie wcześniejsze wersje szły w pikselach (prążek 1 px co 3 px, potem 2 px co 6 px)
   i obie wyglądały krzywo: 16 px paska rocznego nie dzieli się przez 6, więc ostatni
   pas był ucięty w połowie, górny pas wychodził szerszy niż dolny. Owner zobaczył
   to na żywo 2026-09-02 i zgłosił jako brak symetrii.

   Teraz wysokość dzieli się na PIĘĆ RÓWNYCH PASÓW: kolor, prążek, kolor, prążek, kolor.
   Każdy po 20% wysokości, więc wzór jest symetryczny względem środka, a na górze
   i na dole zostaje tyle samo koloru — niezależnie od tego, czy element ma 16 px
   (pasek roczny), czy 35 px (kratka miesiąca). Prążki są przy okazji grubsze
   niż w obu poprzednich podejściach: 3,2 px na pasku rocznym zamiast 1 px i 2 px. */
.vacation-partial {
    background-image: linear-gradient(
        to bottom,
        transparent 20%,
        rgba(255, 255, 255, 0.85) 20%,
        rgba(255, 255, 255, 0.85) 40%,
        transparent 40%,
        transparent 60%,
        rgba(255, 255, 255, 0.85) 60%,
        rgba(255, 255, 255, 0.85) 80%,
        transparent 80%
    );
}
`, "",{"version":3,"sources":["webpack://./src/Vacations/Vacations.css"],"names":[],"mappings":"AAAA;;0BAE0B;;AAE1B;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,cAAc;AAClB;;AAEA;2EAC2E;AAC3E;IACI,SAAS;IACT,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;;;sEAGsE;AACtE;;;IAGI,mBAAmB;AACvB;;AAEA;0EAC0E;AAC1E;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;wDACwD;AACxD;IACI,UAAU;IACV,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;;2BAE2B;AAC3B;IACI,aAAa;IACb,wCAAwC;IACxC,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,aAAa,EAAE,8FAA8F;IAC7G,kBAAkB;AACtB;;AAEA,wFAAwF;AACxF;IACI,WAAW;AACf;;AAEA;6EAC6E;AAC7E;IACI,qBAAqB;IACrB,sBAAsB;IACtB,WAAW;IACX,uBAAuB;IACvB,6BAA6B;IAC7B,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;kFACkF;AAClF;IACI,sDAAsD;AAC1D;;AAEA,2CAA2C;AAC3C;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,2BAA2B;IAC3B,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;IACV,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,YAAY;IACZ,cAAc;IACd,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,yCAAyC;AAC7C;;AAEA,0EAA0E;AAC1E;IACI,WAAW;AACf;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,6CAA6C;IAC7C,oBAAoB;AACxB;;AAEA,qFAAqF;AACrF;IACI,iDAAiD;IACjD;;;;;;KAMC;IACD,mCAAmC;AACvC;;AAEA;;kEAEkE;AAClE;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,WAAW;AACf;;AAEA;8EAC8E;AAC9E;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV,2BAA2B;IAC3B,mCAAmC;IACnC,UAAU;IACV,oBAAoB;AACxB;;AAEA,qEAAqE;AACrE;IACI;8CAC0C;AAC9C;;AAEA,gDAAgD;AAChD;IACI;;8CAE0C;AAC9C;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB;;6CAEyC;AAC7C;;AAEA;;;;;;;;;;;;;;;;;;;;;oFAqBoF;AACpF;IACI;;;;;;;;;;KAUC;AACL","sourcesContent":["/* Style zakładki Urlopy (Biuro → Urlopy). Wydzielone ze Scrumboard.css razem\n   z komponentem: strona nie jest już częścią scrumboardu, więc nie powinna ciągnąć\n   za sobą jego arkusza. */\n\n.vacations-scroll {\n    overflow-x: auto;\n}\n\n.vacation-legend {\n    font-size: 0.85rem;\n}\n\n.vacation-legend-item {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.3rem;\n    white-space: nowrap;\n}\n\n.vacation-swatch,\n.vacation-bar {\n    border-radius: 0.2rem;\n}\n\n.vacation-swatch {\n    display: inline-block;\n    width: 0.9rem;\n    height: 0.9rem;\n}\n\n/* Kolumny osoby i urlopu — dynamiczne, zwężone do treści (width:1% + nowrap),\n   dzięki czemu dni miesiąca / timeline dostają całą pozostałą szerokość. */\n.vacation-name-col {\n    width: 1%;\n    white-space: nowrap;\n    vertical-align: middle;\n}\n\n.vacation-balance-col {\n    width: 1%;\n    white-space: nowrap;\n    vertical-align: middle;\n}\n\n/* Wspólna wysokość treści sald: zwiniętej, rozwiniętej i nagłówka. Bez niej\n   zwinięcie skracałoby wiersze, bo goła liczba jest niższa niż pole edycji.\n   Szerokości zostają naturalne (width: 1% + nowrap), więc nic nie jest wpisane\n   na sztywno i nic się nie obetnie przy nietypowo długiej wartości. */\n.vacation-balance-head-row,\n.vacation-pool-grid,\n.vacation-balance-row {\n    min-height: 1.65rem;\n}\n\n/* Nagłówek sald jest przełącznikiem zwijania — stąd kursor i brak zaznaczania\n   tekstu przy podwójnym kliku. Bez podkreślenia: reaguje sama strzałka. */\n.vacation-balance-head {\n    cursor: pointer;\n    user-select: none;\n}\n\n.vacation-balance-head-row {\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n}\n\n/* margin-left: auto dosuwa strzałkę do prawej krawędzi kolumny — zwiniętej tuż za\n   \"święta\", rozwiniętej na końcu kolumny \"Za święta\". */\n.vacation-chevron {\n    flex: none;\n    margin-left: auto;\n    padding-left: 0.5rem;\n    font-size: 0.7rem;\n    line-height: 1;\n    color: var(--bs-secondary-color, #6c757d);\n}\n\n/* Widok zwinięty: trzy pule obok siebie. Ta sama siatka w nagłówku (etykiety)\n   i w komórkach (liczby), więc \"2\" zawsze stoi pod \"opieka\" bez ręcznego\n   dobierania szerokości. */\n.vacation-pool-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 3.1rem);\n    align-items: center;\n    gap: 0.15rem;\n    text-align: center;\n    font-size: 0.8rem;\n    line-height: 1.4;\n}\n\n.vacation-pool-labels {\n    min-height: 0;\n    font-size: 0.65rem;\n    font-weight: 400;\n    text-transform: lowercase;\n    color: var(--bs-secondary-color, #6c757d);\n}\n\n.vacation-balance-row {\n    display: flex;\n    align-items: center;\n    gap: 0.35rem;\n    font-size: 0.78rem;\n    white-space: nowrap;\n}\n\n.vacation-limit-field {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.2rem;\n    margin: 0;\n}\n\n.vacation-limit-input {\n    width: 3rem;\n    padding: 0.1rem 0.25rem;\n    min-height: 0; /* zdejmuje stałą min-height form-control-sm, by input miał tę samą wysokość co span odczytu */\n    text-align: center;\n}\n\n/* Stała szerokość etykiety miesiąca — strzałki ‹ › nie przeskakują między miesiącami. */\n.vacation-month-label {\n    width: 7rem;\n}\n\n/* Wartość limitu w trybie odczytu — ten sam gabaryt co input (form-control-sm),\n   dzięki czemu wiersz nie zmienia wysokości przy wejściu/wyjściu z edycji. */\n.vacation-limit-value {\n    display: inline-block;\n    box-sizing: border-box;\n    width: 3rem;\n    padding: 0.1rem 0.25rem;\n    border: 1px solid transparent;\n    border-radius: 0.25rem;\n    font-size: 0.875rem;\n    line-height: 1.5;\n    text-align: center;\n    cursor: pointer;\n}\n\n/* Podświetlenie pod kursorem — to jedyne, co polu limitu dawała wspólna klasa\n   .scrum-inline-value ze Scrumboard.css; reszta jej reguł i tak była nadpisana. */\n.vacation-limit-value:hover {\n    background-color: var(--bs-warning-bg-subtle, #fff3cd);\n}\n\n/* Widok roczny — proporcjonalny timeline */\n.vacation-year td,\n.vacation-year th {\n    vertical-align: middle;\n}\n\n.vacation-track {\n    position: relative;\n    height: 100%;\n    min-height: 1.9rem;\n    min-width: 40rem;\n    width: 100%;\n}\n\n.vacation-track-header {\n    height: 1.1rem;\n    min-height: 0;\n}\n\n.vacation-tick {\n    position: absolute;\n    top: 0;\n    transform: translateX(-2px);\n    font-size: 0.7rem;\n    color: var(--bs-secondary, #6c757d);\n}\n\n.vacation-gridline {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: 1px;\n    background: var(--bs-border-color, #dee2e6);\n}\n\n.vacation-bar {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    height: 1rem;\n    min-width: 3px;\n    cursor: pointer;\n    opacity: 0.9;\n}\n\n.vacation-bar:hover {\n    opacity: 1;\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);\n}\n\n/* Widok miesięczny — siatka dni rozciąga się na całą dostępną szerokość */\n.vacation-month {\n    width: 100%;\n}\n\n.vacation-day-head,\n.vacation-day-cell {\n    min-width: 1.4rem;\n    text-align: center;\n    padding: 0.15rem 0;\n}\n\n.vacation-day-head {\n    font-size: 0.75rem;\n}\n\n.vacation-day-cell {\n    height: 1.6rem;\n    cursor: pointer;\n}\n\n.vacation-day-cell:hover {\n    outline: 1px solid var(--bs-primary, #0d6efd);\n    outline-offset: -1px;\n}\n\n/* Weekend zawsze wyszarzony (także wewnątrz zakresu urlopu — nie liczy się do dni) */\n.vacation-weekend {\n    background-color: var(--bs-secondary-bg, #e9ecef);\n    background-image: repeating-linear-gradient(\n        45deg,\n        rgba(0, 0, 0, 0.05) 0,\n        rgba(0, 0, 0, 0.05) 2px,\n        transparent 2px,\n        transparent 4px\n    );\n    color: var(--bs-secondary, #6c757d);\n}\n\n/* Kolumna timeline: bez pionowych marginesów + trik height:1px, dzięki któremu\n   .vacation-track (height:100%) wypełnia pełną wysokość wiersza —\n   linia \"dziś\" jest wtedy ciągła (bez przerw między wierszami). */\n.vacation-timeline-cell {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    height: 1px;\n}\n\n/* Wskaźnik \"dziś\" — widok roczny: jedna ciągła pionowa linia.\n   Anchor = komórka (pełna wysokość wiersza), wyciek ±1px kryje obramowania. */\n.vacation-today-line {\n    position: absolute;\n    top: -1px;\n    bottom: -1px;\n    width: 2px;\n    transform: translateX(-1px);\n    background: rgba(220, 53, 69, 0.55);\n    z-index: 3;\n    pointer-events: none;\n}\n\n/* Wskaźnik \"dziś\" — widok miesięczny: subtelna ramka kolumny dnia. */\n.vacation-day-cell.vacation-today {\n    box-shadow: inset 1px 0 0 rgba(220, 53, 69, 0.55),\n        inset -1px 0 0 rgba(220, 53, 69, 0.55);\n}\n\n/* Domknięcie ramki dołem na ostatnim wierszu. */\n.vacation-month tbody tr:last-child .vacation-day-cell.vacation-today {\n    box-shadow: inset 1px 0 0 rgba(220, 53, 69, 0.55),\n        inset -1px 0 0 rgba(220, 53, 69, 0.55),\n        inset 0 -1px 0 rgba(220, 53, 69, 0.55);\n}\n\n.vacation-day-head.vacation-today {\n    background-color: rgba(220, 53, 69, 0.08);\n    font-weight: 600;\n    box-shadow: inset 1px 0 0 rgba(220, 53, 69, 0.55),\n        inset -1px 0 0 rgba(220, 53, 69, 0.55),\n        inset 0 1px 0 rgba(220, 53, 69, 0.55);\n}\n\n/* Nieobecność na CZĘŚĆ DNIA — poziome prążki zamiast litego wypełnienia.\n   TA SAMA klasa dla kratki miesiąca i dla paska rocznego: paski biegną w poprzek\n   wąskiego wymiaru, więc na pasku szerokim na 3 px nadal daje się je policzyć,\n   a pionowe zmieściłyby się tam najwyżej raz.\n\n   Znacznik jest DWUSTANOWY, nie miarą: 1 h i 7 h wyglądają identycznie. Różnica\n   między 6 h a 7 h jest w kratce 26 px nieczytelna, a udawanie, że jest czytelna,\n   wprowadzałoby w błąd. Liczbę godzin niesie dymek i okno edycji.\n\n   Kolizji z weekendem nie ma: weekend rysuje się na ukos (45°), część dnia poziomo.\n\n   WZÓR LICZONY W UŁAMKACH WYSOKOŚCI, NIE W PIKSELACH — i to jest sedno tej reguły.\n   Dwie wcześniejsze wersje szły w pikselach (prążek 1 px co 3 px, potem 2 px co 6 px)\n   i obie wyglądały krzywo: 16 px paska rocznego nie dzieli się przez 6, więc ostatni\n   pas był ucięty w połowie, górny pas wychodził szerszy niż dolny. Owner zobaczył\n   to na żywo 2026-09-02 i zgłosił jako brak symetrii.\n\n   Teraz wysokość dzieli się na PIĘĆ RÓWNYCH PASÓW: kolor, prążek, kolor, prążek, kolor.\n   Każdy po 20% wysokości, więc wzór jest symetryczny względem środka, a na górze\n   i na dole zostaje tyle samo koloru — niezależnie od tego, czy element ma 16 px\n   (pasek roczny), czy 35 px (kratka miesiąca). Prążki są przy okazji grubsze\n   niż w obu poprzednich podejściach: 3,2 px na pasku rocznym zamiast 1 px i 2 px. */\n.vacation-partial {\n    background-image: linear-gradient(\n        to bottom,\n        transparent 20%,\n        rgba(255, 255, 255, 0.85) 20%,\n        rgba(255, 255, 255, 0.85) 40%,\n        transparent 40%,\n        transparent 60%,\n        rgba(255, 255, 255, 0.85) 60%,\n        rgba(255, 255, 255, 0.85) 80%,\n        transparent 80%\n    );\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
